import { Affix } from '@mantine/core';
import { sumBy } from 'lodash-es';
import { useMemo } from 'react';
import { MultiSelectAll } from 'src/components/common/MultiSelect/MultiSelectAll';
import { Content } from 'src/contexts/ContentContext';
import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { ActionOutboxEntityType, EventWithData } from 'src/WebApiController';

import * as styles from './MobileEventTileBulkActions.css';

export const MobileEventTilesBulkActions = ({
  entityType,
  events,
  onBulkActionsClick,
}: {
  entityType: ActionOutboxEntityType;
  events: EventWithData[];
  onBulkActionsClick: () => void;
}) => {
  const { selectionMode, totalItemsSelected } = useMultiSelectionContext();

  const entityCount = useMemo(() => {
    if (entityType === ActionOutboxEntityType.Purchase) {
      return sumBy(events, (event) => event.counts.tktGrpsCnt ?? 0);
    }
    if (entityType === ActionOutboxEntityType.Sale) {
      return sumBy(events, (event) => event.counts.salesCnt ?? 0);
    }
    return sumBy(events, (event) => event.counts.listCnt ?? 0);
  }, [entityType, events]);

  if (!selectionMode) {
    return null;
  }

  return (
    <Affix
      position={{
        bottom: vars.spacing.lg,
        left: vars.spacing.lg,
        right: vars.spacing.lg,
      }}
      zIndex={50}
    >
      <Stack
        direction="row"
        gap="l"
        alignItems="center"
        justifyContent="spaceBetween"
        width="full"
      >
        <MultiSelectAll
          displayMode="count-only-button"
          className={styles.selectAllButton}
          customCountLabel={entityCount + ''}
        />
        <Button
          shape="rect"
          onClick={onBulkActionsClick}
          disabled={totalItemsSelected === 0}
          className={styles.actionsButton}
        >
          <Content id={ContentId.Actions} />
        </Button>
      </Stack>
    </Affix>
  );
};
